import React from 'react'
import './ContactForm.scss'
import FormTag from './Templates/FormTag'
import SubmitButton from './Buttons/SubmitButton'
import FormLegend from './Templates/FormLegend'
import ValueTrackFields from './ValueTrack/ValueTrackFields'
import {useTranslation} from 'react-i18next'
import Checkbox from './Fields/Checkbox'
import {Link} from 'gatsby-plugin-react-i18next'
import * as routes from '../../constants/routes'
import Field from './Fields/Field'
import Textarea from './Fields/Textarea'
import LanguageField from './Fields/LanguageField'
import useHtmlForm from '../../hooks/useHtmlForm'
import * as paths from '../../constants/paths'
import {ContactFormSubmitted} from '../../helpers/gtm/gtmEvents'
import {removeValueTrackCookie} from '../../helpers/valueTrack'

const ContactForm = () => {
    const {t} = useTranslation()

    const successCallback = (responseData, formData) => {
        ContactFormSubmitted(responseData, formData)
        removeValueTrackCookie()
    }

    const {isSubmitted, hasError, formRef, submit} = useHtmlForm(paths.CONTACT_FORM, successCallback)

    return (
        <div className="contact-form-wrapper">
            {isSubmitted ? (
                <h3
                    id="contact-add-success"
                    className="is-size-4 has-text-weight-semibold has-text-success has-text-centered"
                >
                    {t('contact_message-sent')}
                </h3>
            ) : (
                <>
                    <h2 className="is-size-2 is-size-3-mobile has-text-primary has-text-weight-semibold">
                        {t('contact_send-message')}
                    </h2>
                    {hasError && <p className="has-text-primary">{t('contact_message-error')}</p>}
                    <FormTag id={'contact-form'} ref={formRef}>
                        <Field label={t('contact_form_name')} name={'name'} isRequired={true} />
                        <Field label={t('contact_form_surname')} name={'surname'} isRequired={true} />
                        <Field label={t('contact_form_email')} name={'email'} type={'email'} isRequired={true} />
                        <Textarea label={t('contact_form_message')} name={'message'} isRequired={true} />
                        <Checkbox name={'consent'} isRequired={true}>
                            {t('contact_form_consent')}
                            <Link className="has-text-primary" to={routes.TERMS}>
                                {t('contact_form_consent_link')}
                            </Link>
                        </Checkbox>
                        <LanguageField />
                        <ValueTrackFields />
                        <FormLegend required />
                        <SubmitButton
                            buttonId="contact-add"
                            onClick={submit}
                            label={t('contact_submit')}
                            size={'is-medium'}
                            position={'right'}
                        />
                    </FormTag>
                </>
            )}
        </div>
    )
}

export default ContactForm
